export default function masks() {
    $("#phone").mask("(00) 00000-0000");
}
